import { State } from '@/features/game-context/types';

const configuration =
  process.env.NODE_CONFIG && JSON.parse(process.env.NODE_CONFIG);

const env = process.env.NODE_CONFIG_ENV;

const applicationId = process.env.APPLICATION;

type ValueByState = {
  [state: string]: string;
};

export type GeocomplyEnv =
  | { type: 'devStack'; name: string }
  | { type: 'prod' | 'cert' | 'qa' };

type Config = {
  env?: string;
  geocomplyEnv?: GeocomplyEnv;
  fgp: {
    host: ValueByState;
    GLSInitPath: string;
    FGPUpdatePath: string;
  };
  geolocation: {
    installerKey: string;
    clientAuthToken: string;
    serviceName: string;
    country?: 'US' | 'CA';
  };
  cpp: {
    brandCode: string;
    platformCode: {
      ios: string;
      android: string;
      mobile: string;
      desktop: string;
    };
  };
  lobbyUrl: string;
  logging: {
    applicationId: string;
    clientToken: string;
    site: string;
    service: string;
    sampleRate: number;
  };
  gcmLib: {
    [state in State]: {
      stage: string;
      prod: string;
    };
  };
  fusion: {
    [state in State]: {
      stage: string;
      prod: string;
    };
  };
};

const config: Config = configuration ?? {};
// eslint-disable-next-line no-console
console.log(
  `Application "${applicationId}" loaded with configuration for "${env}" environment`,
);

export default config;
